module.exports = __webpack_public_path__ + "img/hand_up_icon.d4a8dcd6.png";